// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Notify from "@bg/App/Components/Notify";
import { SectionContainer, SectionTitle } from "@bg/App/Widgets/DesignSystem/DesignSystem.helpers";
import GridItem from "@insite/mobius/GridItem";
import React, { FC } from "react";

// TODO: we need to override some props in notify like messageType and showCloseButton
const NotifyTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem width={12}>
                <SectionTitle>Notify</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <Notify messageType="success" showCloseButton={true}>
                    Success Notification: Additional Copy Goes Here
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify messageType="danger" showCloseButton={true}>
                    Danger Notification: Additional Copy Goes Here
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify messageType="info" showCloseButton={true}>
                    Info Notification: Additional Copy Goes Here
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify messageType="warning" showCloseButton={true}>
                    Warning Notification: additional Copy Goes Here
                </Notify>
            </GridItem>
        </SectionContainer>
    );
};

export default NotifyTab;
